import { Grid, Typography } from "@mui/material";
import { useParams, Link } from "react-router-dom";
import posts from "../../Data/post.json";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import Tarjeta_Portada_Blogs from "../Secciones/Tarjetas/Tarjeta_Portada_Blogs";
import Tarjeta_Contenido_Blog from "../Secciones/Tarjetas/Tarjeta_Contenido_Blog";
import Tarjeta_Novedades from "../Secciones/Tarjetas/Tarjeta_Novedades";
import { useResponsive } from "../../Modulo_Responsive/Hooks/useResponsive";

const Seccion_Blog_Dinamico = () => {
    const { id } = useParams();
    // ✅ Busca por slug en lugar de url
    const post = posts.find(
        (p) => p.tipo === "blog" && p.slug === `/blog/${id}/`
    );
    const { sCell } = useResponsive();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [id]);

    if (!post) {
        return (
            <Grid
                container
                justifyContent="center"
                alignItems="center"
                sx={{ minHeight: "50vh", pt: 20 }}
            >
                <Typography variant="h6">Post no encontrado</Typography>
                <Grid container justifyContent="center" sx={{ mt: 2 }}>
                    <Link
                        to="/blogs/"
                        style={{ textDecoration: "none", color: "#000", fontWeight: 600 }}
                    >
                        Volver al blog
                    </Link>
                </Grid>
            </Grid>
        );
    }

    const otrosPosts = posts.filter(
        (p) => p.tipo === "blog" && p.id !== post.id
    );

    return (
        <>
            <Helmet>
                <title>{post.title} </title>
                <meta name="description" content={post.metaDescripcion} />
                <meta name="keywords" content={post.keywords.join(", ")} />
                <meta name="robots" content="index, follow" />
                <link rel="canonical" href={`https://espaciocompacto.com${post.slug}`} />

                <meta property="og:title" content={post.titulo} />
                <meta property="og:description" content={post.metaDescripcion} />
                <meta property="og:url" content={`https://espaciocompacto.com${post.slug}`} />
                <meta property="og:type" content="article" />
                <meta property="og:image" content={`https://espaciocompacto.com${post.imagen}`} />
                <meta property="og:locale" content="es_CO" />

                <meta property="article:author" content={post.autor} />
                <meta property="article:published_time" content={post.fechaPublicacion} />
                <meta property="article:section" content={post.categoria} />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={post.titulo} />
                <meta name="twitter:description" content={post.metaDescripcion} />
                <meta name="twitter:image" content={`https://espaciocompacto.com${post.imagen}`} />

                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Article",
                        headline: post.titulo,
                        description: post.metaDescripcion,
                        image: `https://espaciocompacto.com${post.imagen}`,
                        author: {
                            "@type": "Person",
                            name: post.autor,
                        },
                        publisher: {
                            "@type": "Organization",
                            name: "Espacio Compacto",
                            logo: {
                                "@type": "ImageObject",
                                url: "https://espaciocompacto.com/Espaci_Compacto.png",
                            },
                        },
                        datePublished: post.fechaPublicacion,
                        mainEntityOfPage: {
                            "@type": "WebPage",
                            "@id": `https://espaciocompacto.com${post.slug}`,
                        },
                    })}
                </script>
            </Helmet>

            <Grid
                container
                justifyContent="center"
                alignItems="flex-start"
                size={{ xs: 12, sm: 12, md: 12 }}
                sx={{ px: 3, pt: 15, pb: 8 }}
            >
                <Grid
                    container
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    size={{ xs: 12, sm: 12, md: 10 }}
                    sx={{ }}
                >
                    {/* Botón volver */}
                    <Grid container size={{ xs: 12 }} sx={{ pb: 4, maxWidth:1400 }}>
                        <ArrowBackIosNewIcon
                            sx={{ color: "primary.main", fontSize: 20, mr: 1 }}
                        />
                        <Typography
                            component={Link}
                            to="/blogs/"
                            sx={{
                                textDecoration: "none",
                                color: "primary.main",
                                fontWeight: "bold",
                                "&:hover": { textDecoration: "underline" },
                            }}
                        >
                            Volver al blog
                        </Typography>
                    </Grid>

                    {/* Contenido principal */}
                    <Grid
                        container
                        justifyContent="flex-start"
                        alignItems="flex-start"
                        size={{ xs: 12, sm: 8, md: 8 }}
                        sx={{ pr: sCell ? 0 : 6, maxWidth:1400 }}
                    >
                        <Grid container size={{ xs: 12 }}>
                            <Tarjeta_Portada_Blogs
                                titulo={post.titulo}
                                parrafo={post.descripcion}
                                imagen={post.imagen}
                            />
                        </Grid>

                        <Grid container size={{ xs: 12 }} sx={{ py: 4 }}>
                            <Typography variant="body1" sx={{ color: "#666" }}>
                                {post.fechaPublicacion} • Por {post.autor}
                            </Typography>
                        </Grid>

                        <Grid container size={{ xs: 12 }}>
                            {post.contenido.map((seccion, index) => (
                                <Grid size={{ xs: 12 }} key={index}>
                                    <Tarjeta_Contenido_Blog
                                        subtitulo={seccion.subtitulo}
                                        parrafo={seccion.parrafos}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>

                    {/* Sidebar */}
                    <Grid
                        container
                        justifyContent="flex-start"
                        alignItems="flex-start"
                        size={{ xs: 12, sm: 4, md: 4 }}
                        sx={{
                            position: sCell ? "relative" : "sticky",
                            top: sCell ? 0 : "100px",
                            alignSelf: "flex-start", maxWidth:1400
                        }}
                    >
                        <Grid
                            container
                            spacing={3}
                            size={{ xs: 12 }}
                            sx={{ pt: sCell ? 5 : 0 }}
                        >
                            <Grid container size={{ xs: 12 }} sx={{ pb: 2 }}>
                                <Typography component={"h2"} variant="h4" sx={{ fontWeight: 600 }}>
                                    Otros blogs
                                </Typography>
                            </Grid>
                            {otrosPosts.map((otroPost, index) => (
                                <Grid
                                    key={index}
                                    container
                                    alignItems="center"
                                    justifyContent="center"
                                    size={{ xs: 12 }}
                                    sx={{ pt: 1 }}
                                >
                                    <Tarjeta_Novedades
                                        Novedad={otroPost.titulo}
                                        imagen={otroPost.imagen}
                                        link={otroPost.slug}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
};

export default Seccion_Blog_Dinamico;